/* @ngInject */

const ApiCall = ($q, callToWebService) => {

  function apiCall(scope = {}) {

    this.post = (endpoint, data) => {
      const deferred = $q.defer();
      scope.loading = true;
      callToWebService.postCall.call(null, endpoint, data, deferred.resolve, deferred.reject);
      return deferred.promise.finally(() => scope.loading = false);
    };

  };

  // TODO: Borrar propiedades de function al reemplazar apiCall con new apiCall en aplicaci�n.
  apiCall.post = (endpoint, data) => {
    const deferred = $q.defer();
    callToWebService.postCall.call(null, endpoint, data, deferred.resolve, deferred.reject);
    return deferred.promise;
  };

  return apiCall;

};

export default ApiCall;
